import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "other-amount" }
const _hoisted_2 = { class: "other-amount__amount" }
const _hoisted_3 = { class: "other-amount__symbol" }
const _hoisted_4 = {
  class: "other-amount__value",
  "data-testid": "other-amount-value"
}
const _hoisted_5 = {
  key: 0,
  class: "other-amount__min",
  "data-testid": "other-amount-min"
}
const _hoisted_6 = { class: "other-amount__status" }
const _hoisted_7 = {
  key: 0,
  class: "other-amount__error",
  "data-testid": "other-amount-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_V1AmountChip = _resolveComponent("V1AmountChip")!
  const _component_V1NumericKeypad = _resolveComponent("V1NumericKeypad")!
  const _component_V1ScreenScaffold = _resolveComponent("V1ScreenScaffold")!

  return (_openBlock(), _createBlock(_component_V1ScreenScaffold, {
    class: "other-amount-screen",
    title: _ctx.t('superpacman-other-amount-title'),
    "title-align": "center",
    "next-disabled": !_ctx.isValid,
    "data-testid": "other-amount",
    onNext: _ctx.handleContinue
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.currencySymbol), 1),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.displayAmount), 1)
        ]),
        (_ctx.showKeypad && _ctx.minimumAmount > 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.t('other-amount-minimum', { amount: _ctx.formatCurrency(_ctx.minimumAmount) })), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.errorMessage)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.errorMessage), 1))
            : (_openBlock(), _createElementBlock("p", {
                key: 1,
                class: _normalizeClass(["other-amount__badge", { 'other-amount__badge--hidden': !_ctx.nextPaymentMessage }]),
                "data-testid": "other-amount-badge"
              }, _toDisplayString(_ctx.nextPaymentMessage || ""), 3))
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["other-amount__chips", _ctx.showKeypad ? 'other-amount__chips--scroll' : 'other-amount__chips--grid']),
          "data-testid": "other-amount-chips"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chips, (chip) => {
            return (_openBlock(), _createBlock(_component_V1AmountChip, {
              key: _ctx.chipKey(chip),
              label: chip.label,
              selected: _ctx.isChipSelected(chip),
              "data-testid": _ctx.chipTestId(chip),
              onSelect: ($event: any) => (_ctx.selectChip(chip))
            }, null, 8, ["label", "selected", "data-testid", "onSelect"]))
          }), 128))
        ], 2),
        (_ctx.showKeypad)
          ? (_openBlock(), _createBlock(_component_V1NumericKeypad, {
              key: 1,
              class: "other-amount__keypad",
              "allows-decimals": _ctx.meta.allowsDecimals,
              "decimal-separator": _ctx.meta.decimalSeparator,
              "data-testid": "other-amount-keypad",
              onPress: _ctx.onKeypadPress
            }, null, 8, ["allows-decimals", "decimal-separator", "onPress"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["title", "next-disabled", "onNext"]))
}